import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Card, Form, Row, Col } from "react-bootstrap";
import { useForm, useFormState, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import PageLoader from "../../common/Loader";
import { APPORVED, CHEQUE_STATUS } from "../constants";
const UpdateChequeDetails = (props) => {
  const dispatch = useDispatch()
  const { loader   } = useSelector((state) => state.student);
  const [show, setShow] = useState(props.show);
  let validationSchema = Yup.object().shape({
    clearedDate: Yup.string().required("Cleared Date is required"),
    chequeStatus: Yup.string().required("Cheque status is required"),
    reason: Yup.string().required("Reason is required"),
    // ReactSelect:Yup.object().required("Name is required").nullable(),
  });
  
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setError,
    clearErrors,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      chequeStatus: APPORVED
    },
    resolver: yupResolver(validationSchema),
  });
  // const branchWatch = watch("BranchId");
  useEffect(() => {
    setShow(props.show);
    reset();
  }, [props.show]);
  const handleClose = () => {
    setShow(false);
    props.closeModal();
  };
  const handleShow = () => setShow(true);
  const onSubmit = async (data) => {
    console.log(data)
    await props.update(data);
    reset();
  };
  
  
  return (
    <>
      <Modal show={show} size="lg" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Pending Payment Details </Modal.Title>
        </Modal.Header>
        <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <PageLoader loader={loader} >
          <Card>
            <Card.Body>
            <Form.Group
            as={Row}
            className="mb-3 required"
            controlId="formPlaintextEmail"
          >
            <Form.Label column sm="4">
              Resolved Date
            </Form.Label>
            <Col sm="6">
              <Form.Control
                type="date"
                name="name"
                className={`form-control ${errors.clearedDate ? "is-invalid" : ""}`}
                {...register("clearedDate")}
              ></Form.Control>
              <span className="invalid-feedback">{errors.clearedDate?.message}</span>
            </Col>
          </Form.Group>
          <Form.Group
            as={Row}
            className="mb-3 required"
            controlId="formPlaintextEmail"
          >
            <Form.Label column sm="4">
              Status
            </Form.Label>
            <Col sm="6">
              {/* <Form.Control
                type="date"
                name="name"
                className={`form-control ${errors.status ? "is-invalid" : ""}`}
                {...register("status")}
              ></Form.Control> */}
              <div>
                {CHEQUE_STATUS.map((key) => {
                  return (
                    // <div>
                    <Form.Check
                      type="radio"
                      id={key.value}
                      label={key.label}
                      value={key.value}
                      inline
                      // checked={}
                      {...register("chequeStatus", { required: true })}
                    />
                    // </div>
                  );
                })}
              </div>
              <span className="invalid-feedback">{errors.chequeStatus?.message}</span>
            </Col>
          </Form.Group>
          <Form.Group
            as={Row}
            className="mb-3 required"
            controlId="formPlaintextEmail"
          >
            <Form.Label column sm="4">
              Reason
            </Form.Label>
            <Col sm="6">
              <Form.Control
                as="textarea" rows={3}
                name="name"
                className={`form-control ${errors.reason ? "is-invalid" : ""}`}
                {...register("reason")}
              ></Form.Control>
              <span className="invalid-feedback">{errors.reason?.message}</span>
            </Col>
          </Form.Group>
                  
            </Card.Body>
          </Card>
        </PageLoader>
        </Modal.Body>
        <Modal.Footer>

          <Button
                    className="btn app-default-button btn btn-primary"
                    type="submit"
                  >
                    Update 
                  </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
        </Form>

      </Modal>
    </>
  );
};

export default UpdateChequeDetails;
